<template>
  <custom-popup max-width="400" v-model="show" :cons="cons">
    <template>
      <h4 class="p-2 text-center">
        آیا از تصمیم خود برای حذف کد تخفیف اطمینان دارید ؟
      </h4>
    </template>
  </custom-popup>
</template>

<script>
export default {
  name: "discountDelete",
  props: {
    showDelete: Boolean,
    loading: Boolean,
  },
  data() {
    return {
      cons: {
        title: "پاک کردن کد تخفیف",
        buttons: [
          { type: "submit", handler: () => this.$emit("delete") },
          { type: "close", handler: () => (this.show = false) },
        ],
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.showDelete;
      },
      set(value) {
        this.$emit("update:showDelete", value);
      },
    },
  },

  methods: {},
};
</script>

<style></style>
